<template>
  <div class='AIExploit'>
    <div :class="['AIExploit_wrap', isTrade?'_bgImg':'']" v-show="isShow && parentShow">
      <div class="AIExploit_top">
        <span class="AIExploit_header">{{ $i18.language("TradeGPT-AI拓展关键词") }}</span>
        <!-- 操作栏 -->
        <span class="AIExploit_operation" tabindex="1" v-if="showOperation">
          <el-link @click="changeOperation('refresh')" class="operation_change" tabindex="1" :underline="false">{{ $i18.language("换一批申报词") }}<svg-icon class="change-lot" name="change-lot"></svg-icon></el-link>&ensp;|&ensp;
          <el-link @click="changeOperation('del')" :underline="false">{{ $i18.language("已删除推荐词") }}</el-link>&ensp;|&ensp;
          <el-link @click="changeOperation('hide')" :underline="false">{{ $i18.language("隐藏") }}</el-link>
        </span>
      </div>
      <div class="AIExploit_bottom">
        <div class="flex_box" v-if="synonym.result.length || whoLoading.synonym">
          <span class="words_label">
            {{ $i18.language("商品近义词")}}：<el-popover width="300" placement="right" trigger="hover" popper-class="my-customer-popover" :content="$i18.language('指含义上非常相似或可以互换使用的词汇。由于同一个商品可能存在多种叫法，在搜索时可以增加找到相关商品的可能性。例如：“运动鞋”，近义词可能包括“跑鞋”、“训练鞋”等。')">
              <svg-icon slot="reference" class="ai-ex-help" name="ai-ex-help"></svg-icon>
            </el-popover>
          </span>
          <span class="words_value" v-if="!whoLoading.synonym">
            <template v-for="(el, idx) in synonym.result">
              <el-tooltip :content="el.value" v-if="el.showTooltip" :key="el.value">
                <el-tag :style="{ width: tagWidth + 'px' }" :class="[selectedWords.includes(el.value)?'wordsSelected':'']" closable @click="addwords(el)" @close="delwords(el, 'synonym', idx)"><span class="tag-name-text">{{ el.value }}</span></el-tag>
              </el-tooltip>
              <el-tag v-else :style="{ width: tagWidth + 'px' }"  :key="el.value" :class="[selectedWords.includes(el.value)?'wordsSelected':'']" closable @click="addwords(el)" @close="delwords(el, 'synonym', idx)"><span class="tag-name-text">{{ el.value }}</span></el-tag>
            </template>
          </span>
          <el-skeleton v-else animated :rows="2" style="width: 100%;"></el-skeleton>
        </div>
        <div class="flex_box" v-if="gt.result.length || whoLoading.gt">
          <span class="words_label">
            {{ $i18.language("申报名称词")}}：<el-popover width="300" placement="right" trigger="hover" popper-class="my-customer-popover" :content="$i18.language('指商品在进行国际贸易时的可能会使用的海关申报常用词。')">
              <svg-icon slot="reference" class="ai-ex-help" name="ai-ex-help"></svg-icon>
            </el-popover>
          </span>
          <span class="words_value" v-if="!whoLoading.gt">
            <template v-for="(el, idx) in gt.result">
              <el-tooltip :content="el.value" v-if="el.showTooltip" :key="el.value">
                <el-tag :style="{ width: tagWidth + 'px' }" :class="[selectedWords.includes(el.value)?'wordsSelected':'']" closable @click="addwords(el)" @close="delwords(el, 'gt', idx)"><span class="tag-name-text">{{ el.value }}</span></el-tag>
              </el-tooltip>
              <el-tag v-else :style="{ width: tagWidth + 'px' }"  :key="el.value" :class="[selectedWords.includes(el.value)?'wordsSelected':'']" closable @click="addwords(el)" @close="delwords(el, 'gt', idx)"><span class="tag-name-text">{{ el.value }}</span></el-tag>
            </template>
          </span>
          <el-skeleton v-else animated :rows="2" style="width: 100%;"></el-skeleton>
        </div>
        <div class="flex_box" v-if="industry.result.length || whoLoading.industry">
          <span class="words_label">
            {{ $i18.language("相关行业词")}}：<el-popover width="300" placement="right" trigger="hover" popper-class="my-customer-popover" :content="$i18.language('指采购相关商品的上下游行业中的采购商，经常会进行采购的产品词。这些词汇可以帮助用户发现与原关键词相关的其他潜在商品或服务，拓宽搜索范围。')">
              <svg-icon slot="reference" class="ai-ex-help" name="ai-ex-help"></svg-icon>
            </el-popover>
          </span>
          <span v-if="!whoLoading.industry">
            <div v-for="(item, i) in industry.result" :key="i" class="industry_wrap">
              <span class="words_text">{{ item.description }}:&ensp;</span>
              <span class="words_value">
                <template v-for="(el, idx) in item.subRecommendKeywords">
                  <el-tooltip :content="el.value" v-if="el.showTooltip" :key="el.value">
                    <el-tag :style="{ width: tagWidth + 'px' }" :class="[selectedWords.includes(el.value)?'wordsSelected':'']" closable @click="addwords(el)" @close="delwords(el, 'industry')"><span class="tag-name-text">{{ el.value }}</span></el-tag>
                  </el-tooltip>
                  <el-tag v-else :style="{ width: tagWidth + 'px' }" :key="el.value" :class="[selectedWords.includes(el.value)?'wordsSelected':'']" closable @click="addwords(el)" @close="delwords(el, 'industry')"><span class="tag-name-text">{{ el.value }}</span></el-tag>
                </template>
              </span>
            </div>
          </span>
          <el-skeleton v-else animated :rows="3" style="width: 100%;"></el-skeleton>
        </div>
      </div>
    </div>
    <el-dialog class="merge-dialog dialog-deltekeyWords" :title="$i18.language('已删除推荐关键词')" :visible.sync="deleteKeyWordsVisible" destroy-on-close :close-on-click-modal="false" @close="closedeleteKeyWordDialog">
      <el-radio-group v-model="deleteKeyWordsParams.deleteKeyWordsType" size="mini" @change="changeDelType">
        <el-radio-button label="gt">{{ $i18.language('申报名称词') }}</el-radio-button>
        <el-radio-button label="synonym">{{ $i18.language('商品近义词') }}</el-radio-button>
        <el-radio-button label="industry">{{ $i18.language('相关行业词') }}</el-radio-button>
      </el-radio-group>
      <main-table class="merge-table table-bottom" :data="deleteKeyWordsList" :loading="deleteKeyWordTableLoading" :show-page="true" :show-index="false" :show-search="false" @change-page="changeDeleteKeyWordPage" @change-page-size="changeDeleteKeyWordSize">
        <template v-slot:operate="scope">
          <div class="operation">
            <div class="text-btn" @click="restoreKeyWords(scope.row)" :class="isActiveRestoreFn(scope.row.id) ? 'text-btn-color' : 'text-btn'">{{ isActiveRestoreFn(scope.row.id) ? $i18.language('已恢复') : $i18.language('恢复') }}</div>
          </div>
        </template>
        <empty class="empty-table" slot="empty"></empty>
      </main-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: [Object],
      default: () => {
        return {}
      }
    },
    productDescriptions: {
      type: [Array],
      default: () => {
        return []
      }
    },
    // 是否展示操作
    showOperation: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    selectedWords() {
      let keys = this.productDescriptions.map(item=>item.value)
      return keys
    },
    parentShow() {
      let flag = this.synonym.result.length || this.industry.result.length || this.gt.result.length
      if (this.whoLoading.gt || this.whoLoading.synonym || this.whoLoading.industry) {
        return true
      }
      return flag
    },
    isTrade() {
      return this.$route.path.includes('/trade/result') ? true : false
    }
  },
  data() {
    return {
      isShow: false,
      deleteKeyWordsVisible: false,
      whoLoading: {
        industry: false,
        synonym: false,
        gt: false,
      },
      deleteKeyWordTableLoading: false,
      tempWords: [],
      lang: localStorage.getItem("language"),
      deleteKeyWordsParams: {
        pageIndex: 1,
        pageSize: 10,
        deleteKeyWordsType: "gt"
      },
      deleteKeyWordsList: { //删除关键字集合
        pageIndex: 1,
        pageSize: 10,
        result: [],
        total: 0,
      },
      tagWidth: 180,
      restoreKeyWordsList: [],
      recommendKeywordParams: {
        pageIndex: 1,
        pageSize: 10,
        keyword: "",
      },
      industry: {
        result: [],
        total: 0
      },
      synonym: {
        result: [],
        total: 0
      },
      gt: {
        result: [],
        total: 0
      },
    };
  },
  methods: {
    changeDelType() {
      this.restoreKeyWordsList = []
      this.deleteKeyWordsList.pageIndex = 1
      this.changeDeleteKeyword()
    },
    //切换页数
    changeDeleteKeyWordPage(val) {
      this.deleteKeyWordsList.pageIndex = val
      this.changeDeleteKeyword()
    },
    //切换页码
    changeDeleteKeyWordSize(val) {
      this.deleteKeyWordsList.pageIndex = 1
      this.deleteKeyWordsList.pageSize = val
      this.changeDeleteKeyword()
    },
    // 获取已删除推荐词
    changeDeleteKeyword() {
      let optionList = {
        gt: {
          value: 1,
          function: this.$api.company.getDeleteRecommendKeywords,
        }, 
        synonym: {
          value: 2,
          function: this.$api.company.getRemoveRecommendKeywords,
        },
        industry: {
          value: 3,
          function: this.$api.company.getRemoveRecommendKeywords,
        }
      }
      let params = {
        pageIndex: this.deleteKeyWordsList.pageIndex,
        pageSize: this.deleteKeyWordsList.pageSize,
        recommendType: optionList[this.deleteKeyWordsParams.deleteKeyWordsType].value
      }
      // if (this.deleteKeyWordsParams.deleteKeyWordsType != "gt") {
      //   delete params.pageIndex
      //   delete params.pageSize
      // }
      this.deleteKeyWordsVisible = true
      this.deleteKeyWordTableLoading = true
      optionList[this.deleteKeyWordsParams.deleteKeyWordsType].function(params).then((res) => {
        res.data.columnData = this.$columns.companyDeleteCloumn
        if (this.deleteKeyWordsParams.deleteKeyWordsType != "gt") {
          res.data.result.forEach((el, i) => {
            el.id = el.keyword
            el.value = el.keyword
            el.time = el.removeDate
          })
        }
        let {pageIndex, pageSize} = this.deleteKeyWordsList 
        this.deleteKeyWordsList = {...res.data, pageIndex, pageSize}
        this.deleteKeyWordTableLoading = false
      }).catch((err) => {
        this.deleteKeyWordTableLoading = false
      })
    },
    // 关闭弹框
    closedeleteKeyWordDialog() {
      this.deleteKeyWordsVisible = false
      this.deleteKeyWordTableLoading = false
      this.deleteKeyWordsList.pageIndex = 1
      this.deleteKeyWordsList.pageSize = 10
      this.init()
    },
    // 恢复关键词
    restoreKeyWords(row) {
      let optionList = {
        gt: {
          params: {
            ids: [row.id],
          },
          function: this.$api.company.recoverRecommendKeywords,
        }, 
        synonym: {
          params: {
            keyword: row.id,
            recommendType: 2
          },
          function: this.$api.company.recoveryRecommendKeywords,
        },
        industry: {
          value: 3,
          params: {
            keyword: row.id,
            recommendType: 3
          },
          function: this.$api.company.recoveryRecommendKeywords,
        }
      }
      let type = this.deleteKeyWordsParams.deleteKeyWordsType
      optionList[type].function(optionList[type].params).then((res) => {
        if (res.code == '200') {
          this.changeDeleteKeyword()
        }
      })
    },
    // 判断元素是否选中
    isActiveRestoreFn(id) {
      //index如果不是-1，那就说明是被选中的
      let index = this.restoreKeyWordsList.findIndex((ele) => {
        return ele === id
      })
      if (index != -1) {
        return true
      } else {
        return false
      }
    },
    init() {
      this.isShow = true
      this.loading(true)
      this.recommendKeywordParams.pageIndex = 1
      this.getRecommendKeyword('gt')
      this.getRecommendKeyword('industry')
      this.getRecommendKeyword('synonym')
    },
    loading(flag) {
      this.whoLoading = {
        industry: flag,
        synonym: flag,
        gt: flag
      }
    },
    getRecommendKeyword(type) {
      // recommendType 1为gt关键词
      this.whoLoading[type] = true
      let recommendTypeObj = {
        'gt': 1, // gt关键词
        'synonym': 2, // 近义词
        'industry': 3, // 行业关键词
      }
      this.keywordLoading = true
      // let requestData = JSON.parse(JSON.stringify(this.params))
      let keyword = ""
      let productDescriptions = this.productDescriptions.filter(item=>item.value)
      if(productDescriptions?.length) {
        keyword = productDescriptions[0].value
      } else {
        this.whoLoading[type] = false
        this.isShow = false
        return
      }
      let recommendType = recommendTypeObj[type]??1
      this.$api.trade
        .getAiRecommendKeywords({...this.recommendKeywordParams, keyword, recommendType})
        .then((res) => {
          res.data.result.forEach((item) => {
            if (type == "industry") {
              item.subRecommendKeywords = []
              item.subRecommendKeyword.forEach((el) => {
                item.subRecommendKeywords.push({
                  value: el,
                  showTooltip: el.pxWidth('14px Microsoft YaHei') > this.tagWidth - 34
                })
              })
            }
            item.showTooltip = item.value.pxWidth('14px Microsoft YaHei') > this.tagWidth - 34
          })
          if (type == "gt") {
            setTimeout(() => {
              this[type] = res.data
              this.whoLoading[type] = false
            }, 500);
          } else {
            this[type] = res.data
            this.whoLoading[type] = false
          }
        })
        .catch((err) => {
          this.whoLoading[type] = false
        })
    },
    showAIExploit() {
      this.isShow = true
    },
    hideAIExploit() {
      this.isShow = false
    },
    changeOperation(type) {
      if (type == "hide") {
        this.hideAIExploit()
        this.$emit("changeState", type, this.isShow)
      } else if (type == "refresh") {
        this.changeKeywordPage()
      } else if (type == "del") {
        this.changeDeleteKeyword()
      }
    },
    changeKeywordPage() {
      if (this.recommendKeywordParams.pageSize * this.recommendKeywordParams.pageIndex < this.gt.total) {
        this.recommendKeywordParams.pageIndex += 1
      } else {
        this.recommendKeywordParams.pageIndex = 1
      }
      // 换一批只更新gt智能
      this.getRecommendKeyword('gt')
    },
    addwords(row) {
      if (!this.selectedWords.includes(row.value)) {
        if (this.selectedWords.length >= 10) {
          return this.$message.warning(this.$i18.language("最多输入十个词组"))
        }
        this.$emit("changeState", "addwords", row)
      } else {
        this.$emit("changeState", "delwords", row)
      }
    },
    delwords(row, type) {
      let optionList = {
        gt: {
          function: this.$api.company.excludeItems,
          params: {
            id: row.id,
            type: 1,
          }
        }, 
        synonym: {
          function: this.$api.company.removeRecommendKeywords,
          params: {
            keyword: row.value,
            recommendType: 2,
          }
        },
        industry: {
          function: this.$api.company.removeRecommendKeywords,
          params: {
            keyword: row.value,
            recommendType: 3,
          }
        }
      }
      optionList[type].function(optionList[type].params).then(res => {
        this.getRecommendKeyword(type)
      })
      if (this.selectedWords.includes(row.value)) {
        this.$emit("changeState", "delwords", row)
      }
    },
  },
};
</script>

<style scoped lang="scss">
._bgImg {
  background: url("../assets/company/aiExBg_square.png") center center no-repeat;
  background-size: 100% 100%;
}
.AIExploit_wrap {
  width: 98%;
  min-height: 72px;
  background: url("../assets/company/aiExBg.png") center center no-repeat;
  background-size: 100% 100%;
  // padding: 20px;
  margin: 16px 12px 0;
  overflow: auto;
  border: 1px solid #987afe;
  border-radius: 16px;
  .AIExploit_top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    .AIExploit_header {
      border-top-left-radius: 10px;
      background: url("../assets/company/aiExHeader.png") center center no-repeat;
      background-size: 100% 100%;
      position: relative;
      height: 32px;
      line-height: 32px;
      display: inline-block;
      padding: 0 12px;
      color: #FFFFFF;
      .ai-ex-header {
        position: absolute;
        width: 100%;
      }
    }
    .AIExploit_operation {
      padding-right: 12px;
      .operation_change {
        &:focus {
          .change-lot {
            animation: rotate .3s linear;
          }
        }
      }
      /deep/ .el-link--inner {
        color: $--color-link;
        &:hover {
          color: #0057ba;
        }
      }
      .change-lot {
        margin-left: 6px;
      }
    }
  }
  .AIExploit_bottom {
    margin: 16px;
    margin-top: 0;
    .flex_box {
      display: flex;
      /deep/ .el-skeleton {
        display: flex;
        flex-direction: column;
        .el-skeleton__item {
          height: 24px;
          width: 80%;
          background: linear-gradient(90deg, #dddddd 25%, #ededed 37%, #dddddd 63%);
          background-size: 400% 100%;
        }
        .is-first {
          width: 90%;
        }
        .is-last {
          width: 50%;
          margin-bottom: 16px;
        }
      }
    }
    .words_label {
      color: $--color-title;
      font-weight: 500;
      height: 26px;
      line-height: 26px;
      margin-bottom: 12px;
      white-space: nowrap;
      .ai-ex-help {
        margin: 0 10px;
      }
    }
    .words_text {
      color: $--color-desc;
      text-wrap: nowrap;
    }
    .words_value {
      display: flex;
      flex-wrap: wrap;
      .el-tag {
        cursor: pointer;
        color: $--font-color-primary-6;
        margin-right: 10px;
        border: 1px solid #788FA6;
        line-height: 1.5;
        margin-bottom: 12px;
        padding: 0 8px;
        display: flex;
        align-items: center;
        // border: 1px solid $--border-primary-color;
        // &:hover {
        //   color: $--color-theme;
        //   border: 1px solid $--color-theme;
        // }
        .tag-name-text {
          width: calc(100% - 16px);
          display: inline-block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        /deep/ .el-tag__close {
          color: $--color-title;
          font-size: $--font-size-large;
          background-color: transparent;
          &:hover {
            color: $--color-theme;
          }
        }
      }
      .wordsSelected {
        color: $--color-theme;
        border: 1px solid $--color-theme;
      }
    }
    .industry_wrap {
      display: flex;
      color: $--color-title;
      font-weight: 500;
      line-height: 26px;
    }
  }
}
.el-radio-group {
  margin: 10px 0 0 10px;
}
.text-btn-color{
  color:$--color-font-light;
}
@keyframes rotate {
  from {
    transform: rotate(0deg)
  }
  to {
    transform: rotate(180deg)
  }
}
</style>
<style lang="scss">
.my-customer-popover {
  padding: 10px !important;
  border: 1px solid #d8dee6 !important;
}
</style>
